import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME } from './constants';

class CasWProvider extends BaseApi {
	constructor() {
		super(DMS_MODULE, NAME);
	}

	getCasWByOzn(caswOzn: string) {
		return this.fetch(`${this.apiPath}getCasWByOzn`, { caswOzn });
	}
}


export const apiProvider = new CasWProvider();
